import React, { ChangeEvent, ReactNode } from 'react';
import Select from '@material-ui/core/Select';
import { FormControl, InputLabel, MenuItem } from '@material-ui/core';

export type ValuePickerProps = {
  handleChange?: (event: ChangeEvent<{ name?: string | undefined; value: unknown; }>, child: ReactNode) => void
  value?: string
  items?: ({ value: string, text: string } | string)[] | undefined
  disabled?: boolean
}

function ValuePickerControl(props: ValuePickerProps) {
  const { value, handleChange, items, disabled } = props;
  return (
    <FormControl disabled={disabled}>
      <Select
        labelId="placeholder-label"
        autoWidth={true}
        value={value}
        onChange={handleChange}
      >
        {
          items?.map((item) => {
            let itemValue = '';
            let itemText = '';
            if (typeof item === 'object') {
              itemValue = item.value;
              itemText = item.text;
            } else {
              itemValue = item;
              itemText = item;
            }
            return <MenuItem key={itemValue} value={itemValue}>{itemText}</MenuItem>
          })
        }
      </Select>
    </FormControl>
  )
}


export default ValuePickerControl;
